export const isCustomerIdInArray = (customerId, customersArray) => {
  return customersArray.some(
    (customerObj) => customerObj.customer_id === customerId
  );
};
